import safetyDoctrineImg from 'images/safety/SafetyDoctrine.webp';
import trustGraphicImg from 'images/safety/TrustGraphic.webp';
import bookImg from 'images/safety/Book.webp';
import joinUsImg from 'images/safety/JoinUs.webp';
import safetyFirstBackgroundImg from 'images/safety/SafetyFirstBackground.webp';
import heroSectionImg from 'images/safety/HeroSection.webp';
import eBookImg from 'images/safety/Ebook.webp';

export const safetyDoctrine = (safetyDoctrineImg as any).src || safetyDoctrineImg;
export const trustGraphic = (trustGraphicImg as any).src || trustGraphicImg;
export const book = (bookImg as any).src || bookImg;
export const joinUs = (joinUsImg as any).src || joinUsImg;
export const safetyFirstBackground = (safetyFirstBackgroundImg as any).src || safetyFirstBackgroundImg;
export const heroSection = (heroSectionImg as any).src || heroSectionImg;
export const eBook = (eBookImg as any).src || eBookImg;